import { render, staticRenderFns } from "./sidewidth.vue?vue&type=template&id=2ad3da9a&scoped=true"
import script from "./sidewidth.vue?vue&type=script&lang=js"
export * from "./sidewidth.vue?vue&type=script&lang=js"
import style0 from "./sidewidth.vue?vue&type=style&index=0&id=2ad3da9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad3da9a",
  null
  
)

export default component.exports